import { render, staticRenderFns } from "./RequestRow.vue?vue&type=template&id=b53350e4"
import script from "./RequestRow.vue?vue&type=script&lang=js"
export * from "./RequestRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports